import { cn } from "~/utils/helpers"

interface CellIconGridProps {
  icons?: React.ReactNode[]
  className?: string
}

export const CellIconGrid = ({ icons, className }: CellIconGridProps) => {
  if (!icons || icons.length === 0) return null

  // A 2×2 slot would pin a lone icon to the title row at 12px.
  if (icons.length === 1) {
    return (
      <div className={cn("flex items-center justify-center w-6 self-stretch shrink-0", className)}>
        {icons[0]}
      </div>
    )
  }

  // Fill grid slots: top-left, top-right, bottom-left, bottom-right
  const slots = [icons[0], icons[1], icons[2], icons[3]]

  return (
    <div className={cn("grid grid-cols-2 grid-rows-2 w-6 shrink-0", className)}>
      {slots.map((icon, i) => (
        <div key={i} className="flex items-center justify-center">
          {icon}
        </div>
      ))}
    </div>
  )
}
